import { BroadcastChannel, createLeaderElection, LeaderElector } from 'broadcast-channel';

type WorkerHost = {
  channel: BroadcastChannel;
  elector: LeaderElector | null;
  onPromotion(leaderAppointmentCallback: () => void): void;
};

/**
 * Determines which tab is responsible for hosting the the websocket worker.
 */
const workerHost: WorkerHost = {
  channel: new BroadcastChannel('workerHost', { webWorkerSupport: false }),
  elector: null,
  onPromotion(leaderAppointmentCallback: () => void) {
    workerHost.elector = createLeaderElection(workerHost.channel);
    workerHost.elector.awaitLeadership().then(() => {
      leaderAppointmentCallback();
    });
  },
};

export default workerHost;
